import { render, staticRenderFns } from "./Project.page.vue?vue&type=template&id=8b27853a&"
import script from "./Project.page.vue?vue&type=script&lang=js&"
export * from "./Project.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports